import Head from "next/head";
import Metatags from "../components/Metatags";
import PropTypes from "prop-types";
import TakebackPage from "../components/TakebackPage";
import { getBrandPromos } from "../core/api/brands";
import { getFooter } from "../core/api/core";
import { getTakebackPage } from "../core/api/takeback";
import { getMenu } from "../core/api/menu";

export default function Takeback({ data, menuData, brands, globalData }) {
  return (
    <>
      <Head>
        <title>Reskinned | Takeback</title>
      </Head>
      <Metatags
        metaTitle={data.wagtail.takebackPage.metaTitle}
        metaDescription={data.wagtail.takebackPage.metaDescription}
      />
      <TakebackPage
        pageData={data.wagtail.takebackPage}
        brands={brands}
        navItems={menuData}
        globalData={globalData}
      />
    </>
  );
}

Takeback.propTypes = {
  data: PropTypes.object.isRequired,
  menuData: PropTypes.array.isRequired,
  brands: PropTypes.array.isRequired,
  globalData: PropTypes.object.isRequired,
};

export async function getStaticProps() {
  const { data } = await getTakebackPage();
  const menuData = await getMenu();
  const brands = await getBrandPromos();
  const globalData = await getFooter();

  return {
    props: {
      data,
      menuData,
      globalData,
      brands: brands,
    },
    revalidate: 300,
  };
}
